import './polyfills'
import React, { useRef } from 'react'
import { render } from 'react-dom'
import Main from './views/Main'
import { Provider } from 'react-redux'
import store from './store'
import { useInit } from './store/hooks/init'
import Preloader from './views/Preloader'
import DragDropContext from './components/dnd/DragDropContext'
import { HTMLDatasetUrls } from '../types/Configuration'
import { resolveUrls } from './utils/urls'

const rootEl = document.getElementById('constela-configurator')
const urls = resolveUrls(JSON.parse(rootEl?.dataset.urls ?? 'null') as HTMLDatasetUrls | null)
const mode = rootEl?.dataset.mode

const renderMain = () => <Main />

const ConstelaApp = React.memo(function ConstelaApp() {
  const wrapper = useRef<HTMLDivElement>(null)
  useInit({ urls, wrapper, mode })

  return (
    <div ref={wrapper}>
      <Preloader>{renderMain}</Preloader>
    </div>
  )
})

if (rootEl) {
  render(
    <Provider store={store}>
      <DragDropContext>
        <ConstelaApp />
      </DragDropContext>
    </Provider>,
    rootEl
  )
}
